const APP_NAME = "Veesion Manager";

export default function setDocumentTitle(label) {
  document.title = label ? `${label} · ${APP_NAME}` : APP_NAME;
}
